export default "__VITE_ASSET__CwrzJgtC__"